import { render, staticRenderFns } from "./AddArtwork.vue?vue&type=template&id=16fc41fc&scoped=true&"
import script from "./AddArtwork.vue?vue&type=script&lang=js&"
export * from "./AddArtwork.vue?vue&type=script&lang=js&"
import style0 from "./AddArtwork.vue?vue&type=style&index=0&id=16fc41fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc41fc",
  null
  
)

export default component.exports